import React from 'react';
import withStyles from 'react-jss';
import NavbarStyles from './Navbar.styles';
import MenuIcon from '../icons/MenuIcon';
import { Select, DatePicker, Input } from 'antd';
import moment from 'moment';
import { rangeFilterOptions } from '../../components/pages/VehicleRequests/VehicleRequests.utils';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleSideMenu } from '../SideDrawer/SideDrawer.actions';
import { StylesProps } from 'src/library/types';
import NotificationIcon from 'src/components/pages/Notifications';
import { isInAppNotificationAllowed } from 'src/utils/utils';

interface IProps extends StylesProps<ReturnType<typeof NavbarStyles>> {
  title: string | React.ReactElement;
  toggleSideMenu: () => void;
  leftComponents: () => JSX.Element;
  rightComponents: () => JSX.Element;
}

const renderNotificationIcon = () => {
  if (!isInAppNotificationAllowed()) {
      return null;
  }
  return <NotificationIcon />;
};

const Navbar = (props: IProps): React.ReactElement => {
  const { classes, title, toggleSideMenu, leftComponents, rightComponents } = props;

  return (
    <div className={classes.navbar}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <MenuIcon className={classes.menuButton} onClick={() => toggleSideMenu()} />
        <span className={classes.title}>{title}</span>
        {leftComponents ? leftComponents() : ''}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        {rightComponents && rightComponents()}
        {renderNotificationIcon()}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(
    {
      toggleSideMenu,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(withStyles(NavbarStyles)(Navbar));
